/*@ngInject*/
const PermissionsRepository = function (baseRepository, databaseDownloadSectionName, temporaryLoginTokenRepository) {

    angular.extend(this, baseRepository);

    this.loadPermissionsByUserType = function (userType) {
        var url = '/rest/Permission',
            config = {
                params: {
                    userType: userType
                }
            };
        return this.get(url, config);
    };

    this.updatePermissions = function (permissions) {
        var url = '/rest/Permission';
        return this.post(url, permissions);
    };

    this.loadPermissionActions = function (userType) {
        var id = _.isNil(userType) ? null : userType,
            url = '/rest/Actions',
            config = {
                params: {
                    uri: 'com.firstbest.authorization.Authorization:' + userType
                }
            };

        return this.get(url, config);
    };

    this.backupPermissions = function () {
        var url = '/database/DatabaseDownloadServlet',
            config = {
                params: {
                    sectionName: databaseDownloadSectionName.ASSIGNED_AUTHORIZATIONS
                }
            };

        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.get(url, config);
        });
    }


};

angular.module('ums.configuration')
    .service('permissionsRepository', PermissionsRepository);
